import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledMagnifyingGlassBlueIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_14351_6036",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M21.5 9C26.7467 9 31 13.2533 31 18.5C31 23.7467 26.7467 28 21.5 28C16.2533 28 12 23.7467 12 18.5C12 13.2533 16.2533 9 21.5 9ZM21.5 12.0996C17.9654 12.0996 15.0996 14.9654 15.0996 18.5C15.0996 22.0346 17.9654 24.9004 21.5 24.9004C25.0346 24.9004 27.9004 22.0346 27.9004 18.5C27.9004 14.9654 25.0346 12.0996 21.5 12.0996Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 9C26.7467 9 31 13.2533 31 18.5C31 23.7467 26.7467 28 21.5 28C16.2533 28 12 23.7467 12 18.5C12 13.2533 16.2533 9 21.5 9ZM21.5 12.0996C17.9654 12.0996 15.0996 14.9654 15.0996 18.5C15.0996 22.0346 17.9654 24.9004 21.5 24.9004C25.0346 24.9004 27.9004 22.0346 27.9004 18.5C27.9004 14.9654 25.0346 12.0996 21.5 12.0996Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 12.0996L21.5 11.0996H21.5V12.0996ZM15.0996 18.5H14.0996V18.5L15.0996 18.5ZM21.5 24.9004V25.9004H21.5L21.5 24.9004ZM27.9004 18.5L28.9004 18.5V18.5H27.9004ZM21.5 9V10C26.1944 10 30 13.8056 30 18.5H31H32C32 12.701 27.299 8 21.5 8V9ZM31 18.5H30C30 23.1944 26.1944 27 21.5 27V28V29C27.299 29 32 24.299 32 18.5H31ZM21.5 28V27C16.8056 27 13 23.1944 13 18.5H12H11C11 24.299 15.701 29 21.5 29V28ZM12 18.5H13C13 13.8056 16.8056 10 21.5 10V9V8C15.701 8 11 12.701 11 18.5H12ZM21.5 12.0996V11.0996C17.4131 11.0996 14.0996 14.4131 14.0996 18.5H15.0996H16.0996C16.0996 15.5177 18.5177 13.0996 21.5 13.0996V12.0996ZM15.0996 18.5L14.0996 18.5C14.0996 22.5869 17.4131 25.9004 21.5 25.9004V24.9004V23.9004C18.5177 23.9004 16.0996 21.4823 16.0996 18.5L15.0996 18.5ZM21.5 24.9004L21.5 25.9004C25.5869 25.9004 28.9004 22.5869 28.9004 18.5L27.9004 18.5L26.9004 18.5C26.9004 21.4823 24.4823 23.9004 21.5 23.9004L21.5 24.9004ZM27.9004 18.5H28.9004C28.9004 14.4131 25.5869 11.0996 21.5 11.0996L21.5 12.0996L21.5 13.0996C24.4823 13.0996 26.9004 15.5177 26.9004 18.5H27.9004Z",
			fill: "#1F3B44",
			mask: "url(#path-2-inside-1_14351_6036)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0809 24.0808C14.5886 23.5731 15.4121 23.5731 15.9197 24.0808C16.4271 24.5885 16.4273 25.4121 15.9197 25.9197L10.9197 30.9197C10.4122 31.4273 9.58858 31.4271 9.08087 30.9197C8.57319 30.412 8.57319 29.5885 9.08087 29.0808L14.0809 24.0808Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 15L21.5 16.1547V18.4641L19.5 19.6188L17.5 18.4641V16.1547L19.5 15Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 15L25.5 16.1547V18.4641L23.5 19.6188L21.5 18.4641V16.1547L23.5 15Z",
			fill: "white",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 18.5L23.5 19.6547V21.9641L21.5 23.1188L19.5 21.9641V19.6547L21.5 18.5Z",
			fill: "white",
			stroke: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledMagnifyingGlassBlueIcon);
const Memo = memo(ForwardRef);
export default Memo;
